import React from "react";
const Context = React.createContext(null);
const ToolbarBoundaryProvider = ({ editorContainer, children, externalContainer }) => {
  const containerFromConfig = typeof externalContainer === "function" ? externalContainer() ?? void 0 : externalContainer;
  const value = React.useMemo(
    () => containerFromConfig ?? editorContainer,
    [editorContainer, containerFromConfig]
  );
  return /* @__PURE__ */ React.createElement(Context.Provider, { value }, children);
};
const useToolbarBoundary = () => {
  return React.useContext(Context);
};
export {
  ToolbarBoundaryProvider,
  useToolbarBoundary
};
//# sourceMappingURL=toolbar-boundary.js.map
